export const LINK_POST = 'LINK_POST'
export const LINK_UPDATE = 'LINK_UPDATE'
export const LINK_ERROR = 'LINK_ERROR'

export function postLink(payload = {}) {
  return {
    type: LINK_POST,
    payload,
  }
}

export function updateLink(payload = {}) {
  return {
    type: LINK_UPDATE,
    payload,
  }
}

export function errorLink(payload = {}) {
  return {
    type: LINK_ERROR,
    payload,
  }
}
